import React, { useEffect, useState, useRef, RefObject } from 'react'
import ReservationStore from '../../../stores/ReservationStore'
import { useTranslation } from 'react-i18next'

import { InitiateExtEcommercePaymentResponse } from '../../../api/externalPaymentsAPI'
import { observer } from 'mobx-react'
import { getQueryParams } from '../../../utils/helpers'
import { Text } from '@chakra-ui/react'
import { useLocation } from 'react-router-dom'

const getRedirectUrl = (
  paymentData: InitiateExtEcommercePaymentResponse
) => {
  return new Promise<void>((resolve) => {
    return paymentData?.getRedirect?.url;
  })
}

const Payment: React.FC = observer(() => {
  const { t } = useTranslation()
  const location = useLocation()
  const formRef = useRef<HTMLFormElement>(null)
  const [paymentData, setPaymentData] =
    useState<InitiateExtEcommercePaymentResponse | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const startPayment = async () => {
      const bookingCode = getQueryParams(location.search, 'bookingCode')

      if (bookingCode) {
        const [data, error] = await ReservationStore.startPayment(bookingCode)
        if (data) {
          setPaymentData(data)
        } else if (error) {
          setError(error)
        }
      }
    }

    startPayment().catch(console.error)
  }, [location])

  useEffect(() => {

    const renderFormAndSubmit = async () => {


      if (paymentData) {
        const redirect = paymentData?.getRedirect?.url;
        if (redirect) {
          // redirect browser to the payment page
            window.location.href = redirect;
        }
      }
    }

    renderFormAndSubmit().catch(console.error)
  }, [paymentData])

  if (error) {
    return <Text>{error}</Text>
  }
  return (<div id="paymentFormContainer" >
    <Text>{t('redirecting_to_payment_provider')}</Text>
  </div>)
})

export default Payment
